import { useState } from "react";
import { ShareOptions } from "@capacitor/share";
import Icon from "@mdi/react";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { mdiContentCopy, mdiShare } from "@mdi/js";

import useShare from "hooks/useShare";
import useCopyToClipboard from "hooks/useCopyToClipboard";

export interface ShareButtonProps {
  data: ShareOptions;
  loading?: boolean;
}

function ShareButton(props: ShareButtonProps) {
  const { data, loading = false } = props;
  const [copiedTooltip, setCopiedTooltip] = useState(false);
  const { canCopy, copy } = useCopyToClipboard();
  const { canShare, share } = useShare();

  const renderShareButton = () => (
    <IconButton edge='end' aria-label='Share' disabled={loading} onClick={() => share(data)} size='large'>
      {loading ? <CircularProgress size={24} /> : <Icon path={mdiShare} size={1} />}
    </IconButton>
  );

  const renderCopyButton = () => {
    if (!canCopy) {
      return null;
    }

    const textParts: string[] = [];
    if (data.title) {
      textParts.push(data.title);
    }
    if (data.text) {
      textParts.push(data.text);
    }
    if (data.url) {
      textParts.push(data.url);
    }

    return (
      <IconButton
        edge='end'
        aria-label='Copy'
        disabled={loading}
        size='large'
        onClick={() => {
          copy(textParts.join("\n\n"));
          setCopiedTooltip(true);
          setTimeout(() => {
            setCopiedTooltip(false);
          }, 1500);
        }}
      >
        {loading ? (
          <CircularProgress size={24} />
        ) : (
          <Tooltip open={copiedTooltip} title='Copied' placement='left'>
            <Icon path={mdiContentCopy} size={1} />
          </Tooltip>
        )}
      </IconButton>
    );
  };

  return canShare ? renderShareButton() : renderCopyButton();
}

export default ShareButton;
